import { render, staticRenderFns } from "./DesignMenuBar.vue?vue&type=template&id=49e25cb7&scoped=true"
import script from "./DesignMenuBar.vue?vue&type=script&lang=js"
export * from "./DesignMenuBar.vue?vue&type=script&lang=js"
import style0 from "./DesignMenuBar.vue?vue&type=style&index=0&id=49e25cb7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e25cb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49e25cb7')) {
      api.createRecord('49e25cb7', component.options)
    } else {
      api.reload('49e25cb7', component.options)
    }
    module.hot.accept("./DesignMenuBar.vue?vue&type=template&id=49e25cb7&scoped=true", function () {
      api.rerender('49e25cb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeScope2Design/DesignMenuBar.vue"
export default component.exports